module.exports = __webpack_public_path__ + "img/C03TechRiteofRatis_ua.d517d14e.webp";